"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { PaymentMethodCard } from "@/components/billing/payment-method-card";
import { merchantAccountQueryOptions } from "@/api/provider/billing/merchant-account-query";
import { paymentQueryOptions } from "@/api/provider/billing/payment-query";
interface Props {
  patientId: string;
}
export default function PaymentMethodsSection(t0) {
  const $ = _c(19);
  const {
    patientId
  } = t0;
  let t1;
  if ($[0] !== patientId) {
    t1 = paymentQueryOptions.methods(patientId);
    $[0] = patientId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!patientId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: t4,
    isLoading
  } = useQuery(t3);
  let t5;
  if ($[5] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const paymentMethods = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = merchantAccountQueryOptions.list();
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const {
    data: t7
  } = useQuery(t6);
  let t8;
  if ($[8] !== t7) {
    t8 = t7 === undefined ? [] : t7;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const merchantAccounts = t8;
  if (isLoading) {
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="mt-2"><div className="h-4 w-24 animate-pulse rounded bg-muted" /><div className="mt-2 h-10 animate-pulse rounded-md bg-muted" /></div>;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    return t9;
  }
  if (!paymentMethods || paymentMethods.length === 0) {
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <p className="text-caption text-muted-foreground">No payment methods added</p>;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    return t9;
  }
  let t9;
  if ($[12] !== merchantAccounts || $[13] !== paymentMethods) {
    let t10;
    if ($[15] !== merchantAccounts) {
      t10 = method => <PaymentMethodCard key={method.id} method={method} variant="compact" merchantAccounts={merchantAccounts} />;
      $[15] = merchantAccounts;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    t9 = paymentMethods.map(t10);
    $[12] = merchantAccounts;
    $[13] = paymentMethods;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="space-y-2">{t9}</div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}